import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ruleDialog",
  "data-test": "rule-dialog"
}
const _hoisted_2 = { class: "ruleDialog__container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["onClick"]

import { computed } from 'vue';
import { useStore } from '@/store';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const store = useStore();

const content = computed(() => store.state.rule.description);



function onClose () {
  emit('close');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", {
        class: "ruleDialog__content",
        innerHTML: _unref(content)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", {
      class: "ruleDialog__close",
      "data-test": "close-btn",
      onClick: _withModifiers(onClose, ["stop"])
    }, null, 8, _hoisted_4)
  ]))
}
}

})